import c from 'classnames';
import { useLocation } from 'react-router-dom';

import { stringToUrl, userValueFormat } from 'helpers';
import { ActionPlanItem } from 'types/ActionPlan';

import { Icon, TextColor, Typography } from '@repo/ui';
import { TextLink } from 'components';

import styles from './MainFindingItem.module.scss';

interface MainFindingItemProps {
  metric: {
    sample_health_id: number;
    user_value: number;
    user_string?: string;
    evaluation_color: string;
    gvh?: {
      name: string;
      category_title?: string;
      data_type: string;
      kic?: {
        category_title?: string;
        kis?: {
          display_title: string;
        };
      };
    };
  };
  kitId?: string;
  relatedActions: ActionPlanItem[];
}

export const MainFindingItem = ({
  metric,
  kitId,
  relatedActions = [],
}: MainFindingItemProps) => {
  const { pathname } = useLocation();

  return (
    <div className={styles.mainFindingItem}>
      <div className={c(styles.flexRow, styles.greyText)}>
        <Typography variant={'label'}>
          {metric?.gvh?.kic?.kis?.display_title || ''}
        </Typography>
        <Icon name='chevronForward' size='s' />
        <Typography variant={'label'}>
          {metric?.gvh?.category_title || ''}
        </Typography>
      </div>
      <div className={c(styles.evaluation, styles[metric.evaluation_color])}>
        <Typography variant={'heading-m'} className={styles.title}>
          {metric?.gvh?.name}
        </Typography>
        <Typography variant={'heading-m'} className={styles.value}>
          {userValueFormat(
            metric.user_value,
            metric.gvh?.data_type || 'number',
            metric.user_string,
          )}
        </Typography>
      </div>
      <div className={c(styles.footer, styles.alignCenter, styles.gap1)}>
        <div className='flex align-items-center justify-content-between gap-1 w-100'>
          {relatedActions?.length ? (
            <TextLink
              label={`${relatedActions.length} action items`}
              to={`/results/${kitId}/insights/${stringToUrl(
                metric?.gvh?.kic?.kis?.display_title || '',
              )}/${metric?.sample_health_id}`}
              state={{ scrollTo: 'actions', from: pathname }}
              size='heading-s'
              color={TextColor.PURPLE}
            />
          ) : (
            <div></div>
          )}
          <TextLink
            label='Read more'
            iconNameRight='chevronForward'
            to={`/results/${kitId}/insights/${stringToUrl(
              metric?.gvh?.kic?.kis?.display_title || '',
            )}/${metric?.sample_health_id}`}
            state={{ from: pathname }}
            size='heading-s'
            color={TextColor.PURPLE}
          />
        </div>
      </div>
    </div>
  );
};
